export type CurrentListing = {
  id: "harbour-isle-102" | "harbour-isle-106";
  address: string;
  searchLabel: string;
  summary: string;
  virtualTourUrl: string;
  fullListingUrl: string;
};

export const currentListings: CurrentListing[] = [
  {
    id: "harbour-isle-102",
    address: "18 Harbour Isle Dr #102",
    searchLabel: "Search | Teri T Britton",
    summary: "A Harbour Isle residence represented by Teri Tangora Britton.",
    virtualTourUrl: "https://www.propertypanorama.com/18-W-Harbour-Isle-Drive-W-Unit-102-Fort-Pierce-FL-34949/unbranded#tour",
    fullListingUrl: "https://my.flexmls.com/teribritton/search/shared_links/EcoWk/listings/20260503175457941381000000",
  },
  {
    id: "harbour-isle-106",
    address: "20 Harbour Isle Dr W #106",
    searchLabel: "Search | Teri T Britton",
    summary: "A Harbour Isle residence represented by Teri Tangora Britton.",
    virtualTourUrl: "https://www.propertypanorama.com/20-W-Harbour-Isle-Dr-W-W-Unit-106-Fort-Pierce-FL-34949/unbranded#tour",
    fullListingUrl: "https://my.flexmls.com/teribritton/search/shared_links/EcoYO/listings/20260505192739349463000000",
  },
];
